import { render, staticRenderFns } from "./Error401.vue?vue&type=template&id=22d98ac3&"
import script from "./Error401.vue?vue&type=script&lang=js&"
export * from "./Error401.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports